import "metismenu";


angular.module("navigation", [])

.controller("NavigationCtrl", ['$scope', '$rootScope', '$controller', '$state', '$stateParams', 'Restangular', '$uibModal', 'modalService', '$compile', 'gridService', 'uiGridTreeViewConstants', 'treeService', '$timeout', 'LoginService', '$window', 'screenSize', 'logService',
    function ($scope, $rootScope, $controller, $state, $stateParams, Restangular, $uibModal, modalService, $compile, gridService, uiGridTreeViewConstants, treeService, $timeout, LoginService, $window, screenSize, logService) {

    $scope.username = LoginService.get("userName");
    $scope.icon = LoginService.get("userIcon") == "null" ? "assets/img/no-user.jpeg" : LoginService.get("userIcon");
    $scope.finishHtmlLoad = false;
    $rootScope.company_id = LoginService.get("companyId");
    
    $scope.showHideMenu = false;

    $scope.loadMenu = function () {
        Restangular.all(`Menus/${$scope.company.menu_code}/tree`).getList().then(function (results) {
            $scope.menus = results;
            $timeout(function () {
                $scope.finishHtmlLoad = true;
                ($('#side-menu') as any).metisMenu();
            });
        }, function (response) {
            logService.error("Error with status code", response.status);
            if (response.status !== 401) {
                LoginService.closeSession(); //Cerramos si ha devuelto un 440 para que no se quede en bucle entre el login y el dashboard
                $state.go("authinit");
            }
        });
    };

    //Imagen de la empresa
    Restangular.one('Companies', $rootScope.company_id*1).get().then(function (results) {
        $scope.company = results;
        $scope.loadMenu();
    }, function (response) {
        $scope.errorMessage = response.message;
    });

    //no funciona bien
    $scope.isItemActive = function (item) {
        var ret = false;
        if (item.ui_sref != "" && item.ui_sref != null) {
            var parts = item.ui_sref.split(".");
            ret = $state.includes(parts[0]);
            logService.debug(item.ui_sref, ret);
        }
        return ret;
    };
    
    $scope.hideMenu = function (menuItemId) {
        logService.debug(menuItemId);
    }




    $rootScope.$on("language-change", function (event, args) {
        $scope.loadMenu();
    });

    /* RESIZE del menu navbar lateral, para que salga pequeño.*/
    var w = angular.element($window);
    $scope.getWindowDimensions = function () {
        return { 'h': w.height(), 'w': w.width() };
    };
    $scope.$watch($scope.getWindowDimensions, function (newValue, oldValue) {
        $scope.windowHeight = newValue.h;
        $scope.windowWidth = newValue.w;
        if (newValue.w > 769 && newValue.w < 1201) {
            $('body').addClass('mini-navbar')
        }

    }, true);

    //Permite identificar el tamaño de pantalla para poder ajustar las clases de no-paddings etc para que independientemente del tamaño, se visualice correctamente.
    //Utiliza angular-match-media.js (Incluido el fichero directamente, no está en el nugget)
    $scope.$watch(function () {
        $rootScope.sizeLg = screenSize.is('lg');
        $rootScope.sizeMd = screenSize.is('md');
        $rootScope.sizeSm = screenSize.is('sm');
        $rootScope.sizeXs = screenSize.is('xs');
    });

    w.bind('resize', function () {
        if (!$scope.$$phase) $scope.$apply();
    });


    $rootScope.isDefinedAndNotNull = function (val) {
        return angular.isDefined(val) && val !== null
    };

    $rootScope.isDefinedAndNotNullAndNotEmpty = function (val) {
        return angular.isDefined(val) && val !== null && val != ""
    };

}])
;






